var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 50.5,
    cy: 50,
    r: 50,
    fill: "#FF4444"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.5013,
    cy: 49.9998,
    r: 33.3333,
    fill: "#FF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3684 37.0189C39 37.019 38.64 37.1289 38.3344 37.3347C38.0289 37.5405 37.7916 37.8327 37.653 38.174C37.5144 38.5153 37.4807 38.8902 37.5562 39.2508C37.6318 39.6113 37.8132 39.9412 38.0772 40.1981L47.879 49.9999L38.0772 59.8017C37.8994 59.9724 37.7576 60.1767 37.6598 60.4029C37.5621 60.6291 37.5104 60.8725 37.5079 61.1188C37.5054 61.3652 37.5521 61.6096 37.6452 61.8377C37.7383 62.0658 37.876 62.273 38.0503 62.4473C38.2245 62.6215 38.4317 62.7592 38.6598 62.8523C38.8879 62.9454 39.1323 62.9921 39.3787 62.9896C39.6251 62.9871 39.8685 62.9355 40.0946 62.8377C40.3208 62.74 40.5252 62.5981 40.6958 62.4203L50.4976 52.6186L60.2994 62.4203C60.47 62.5981 60.6744 62.74 60.9006 62.8377C61.1268 62.9355 61.3702 62.9871 61.6165 62.9896C61.8629 62.9921 62.1073 62.9455 62.3354 62.8523C62.5635 62.7592 62.7707 62.6215 62.945 62.4473C63.1192 62.2731 63.2569 62.0658 63.35 61.8377C63.4431 61.6096 63.4898 61.3652 63.4873 61.1188C63.4848 60.8725 63.4332 60.6291 63.3354 60.4029C63.2377 60.1767 63.0958 59.9723 62.918 59.8017L53.1162 49.9999L62.918 40.1981C63.1856 39.938 63.3684 39.6031 63.4424 39.2373C63.5164 38.8716 63.4782 38.492 63.3327 38.1483C63.1873 37.8046 62.9414 37.5129 62.6273 37.3114C62.3132 37.1098 61.9456 37.0079 61.5725 37.0189C61.0914 37.0332 60.6348 37.2343 60.2994 37.5795L50.4976 47.3813L40.6958 37.5795C40.5232 37.4021 40.3169 37.2611 40.0889 37.1648C39.8609 37.0685 39.6159 37.0189 39.3684 37.0189Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed);
export default __webpack_public_path__ + "static/media/failed.bd7714b57cf6d07869205f7854ea4ac7.svg";
export { ForwardRef as ReactComponent };